import { render } from "./SectionButtons.vue?vue&type=template&id=fed16f82&ts=true"
import script from "./SectionButtons.vue?vue&type=script&lang=ts"
export * from "./SectionButtons.vue?vue&type=script&lang=ts"

import "./SectionButtons.vue?vue&type=style&index=0&id=fed16f82&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__